import {useSignOut} from '@/hooks/useAuth';
import {graphqlClient} from '@/services/graphqlClient';
import {
  useFinishMyWorkTimeShiftMutation,
  useGetMyWorkTimeStatusQuery,
} from '@/services/graphqlHooks';
import queryClient from '@/services/queryClient';

export function useFinishWork() {
  const signOut = useSignOut();
  const finishWorkMutation = useFinishMyWorkTimeShiftMutation(graphqlClient);

  const finishWork = async (signOutAfterFinish: boolean) => {
    await finishWorkMutation.mutateAsync({});
    await queryClient.invalidateQueries({
      queryKey: useGetMyWorkTimeStatusQuery.getKey(),
    });

    if (signOutAfterFinish) {
      signOut.mutate();
    }
  };

  return {
    finishWork,
    isPending: finishWorkMutation.isPending || signOut.isPending,
  };
}
